import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Body2, Chip, Header, SkeletonLoader } from "@activecollab/components";
import PropTypes from "prop-types";
import ProjectName from "~/components/project/ProjectName";
import { getProjectById } from "~/store/selectors/selector.projects";

const TasksArchiveHeader = ({ loading, completedCounters }) => {
  const { t } = useTranslation();
  const { projectId } = useParams();
  const project = useSelector((state) => getProjectById(state, Number(projectId)).toJS());

  return (
    <Header className="tw-flex tw-justify-between tw-items-center tw-mb-4">
      <div className="tw-flex tw-items-center tw-gap-2">
        {loading ? (
          <SkeletonLoader
            style={{ width: "150px" }}
            data-testid="SkeletonLoader"
          />
        ) : (
          <>
            <Body2
              className=""
              color="secondary"
            >
              <ProjectName passedProject={project} />: {t("Task lists")}
            </Body2>
            <Chip
              backgroundColor="var(--color-theme-300)"
              closeClassName=""
              color="var(--primary)"
              label={completedCounters.TaskLists || 0}
              size="regular"
              typographyProps={{}}
              variant="Caption 1"
            />
            <Body2
              className=""
              color="secondary"
            >
              /
            </Body2>
            <Body2
              className="2"
              color="secondary"
            >
              {t("Tasks")}
            </Body2>
            <Chip
              backgroundColor="var(--color-theme-300)"
              closeClassName=""
              color="var(--primary)"
              label={completedCounters.Tasks || 0}
              size="regular"
              typographyProps={{}}
              variant="Caption 1"
            />
          </>
        )}
      </div>
      <div
        className="tw-flex tw-items-center tw-gap-2"
        id="task-archive-actions"
        data-testid="trash-header-actions"
      ></div>
    </Header>
  );
};

TasksArchiveHeader.displayName = "TasksArchiveHeader";
TasksArchiveHeader.propTypes = {
  loading: PropTypes.bool,
  completedCounters: PropTypes.object,
};

export default TasksArchiveHeader;
